class ServerPixelHandler {

}

module.exports = ServerPixelHandler;
